/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Job } from './Job';
import {
    JobFromJSON,
    JobFromJSONTyped,
    JobToJSON,
    JobToJSONTyped,
} from './Job';

/**
 * 
 * @export
 * @interface AdminGetAllJobs200Response
 */
export interface AdminGetAllJobs200Response {
    /**
     * 
     * @type {Array<Job>}
     * @memberof AdminGetAllJobs200Response
     */
    data?: Array<Job>;
    /**
     * 
     * @type {number}
     * @memberof AdminGetAllJobs200Response
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminGetAllJobs200Response
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminGetAllJobs200Response
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminGetAllJobs200Response
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the AdminGetAllJobs200Response interface.
 */
export function instanceOfAdminGetAllJobs200Response(value: object): value is AdminGetAllJobs200Response {
    return true;
}

export function AdminGetAllJobs200ResponseFromJSON(json: any): AdminGetAllJobs200Response {
    return AdminGetAllJobs200ResponseFromJSONTyped(json, false);
}

export function AdminGetAllJobs200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminGetAllJobs200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(JobFromJSON)),
        'page': json['page'] == null ? undefined : json['page'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'total': json['total'] == null ? undefined : json['total'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
    };
}

  export function AdminGetAllJobs200ResponseToJSON(json: any): AdminGetAllJobs200Response {
      return AdminGetAllJobs200ResponseToJSONTyped(json, false);
  }

  export function AdminGetAllJobs200ResponseToJSONTyped(value?: AdminGetAllJobs200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(JobToJSON)),
        'page': value['page'],
        'limit': value['limit'],
        'total': value['total'],
        'totalPages': value['totalPages'],
    };
}

